import { codeMap } from './http';

/** DB 코드값 ↔ 화면 라벨. 새 값은 db/*.sql CHECK 와 같이 고친다 */
export const LEGAL_FORM = codeMap({ partnership: '조합', advisory: '자문', discretionary: '일임' } as const);
export const DEAL_STAGE = codeMap({ review: '검토', invested: '투자', exited: '회수', writeoff: '상각' } as const);
export const SECURITY = codeMap({ common: '보통주', preferred: '우선주', rcps: 'RCPS', cb: 'CB', safe: 'SAFE' } as const);
export const EXIT_METHOD = codeMap({ secondary: '구주 매각', ipo: 'IPO', mna: 'M&A', redemption: '상환' } as const);
export const RISK_GRADE = codeMap({ growth: '성장', expected: '기대', watch: '관찰', caution: '주의', concern: '우려', danger: '위험' } as const);
export const MGMT_LEVEL = codeMap({ normal: '관리', focus: '집중 관리', closed: '종료' } as const);
export const SHARE_KIND = codeMap({ common: '보통주', preferred: '우선주', cb: 'CB', safe: 'SAFE', option: '스톡옵션' } as const);
